import { useState } from 'react';

const LoyaltyCta = () => {
  const [registered, setRegistered] = useState(false);
  const [phone, setPhone] = useState('');

  return (
    <section className="py-20 px-4 md:px-8 lg:px-12 relative overflow-hidden" style={{ background: '#070710' }}>
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/485472a994050cd180bbb92099d20f9e.jpg"
          alt=""
          className="w-full h-full object-cover object-top"
          style={{ filter: 'brightness(0.15) saturate(1.2)' }}
        />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, rgba(7,7,16,0.9) 0%, rgba(7,7,16,0.7) 50%, rgba(7,7,16,0.9) 100%)' }} />
      </div>

      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full opacity-8" style={{ background: '#f0ff00', filter: 'blur(120px)' }} />

      <div className="max-w-3xl mx-auto text-center relative z-10">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full font-mono text-xs mb-6" style={{ background: 'rgba(240,255,0,0.08)', border: '1px solid rgba(240,255,0,0.25)', color: '#f0ff00' }}>
          <i className="ri-vip-crown-fill" />
          ПРИСОЕДИНЯЙТЕСЬ СЕЙЧАС
        </div>

        <h2 className="font-orbitron font-black text-3xl md:text-5xl text-white mb-4 leading-tight">
          НАЧНИТЕ КОПИТЬ
          <span className="block" style={{ color: '#f0ff00', textShadow: '0 0 30px rgba(240,255,0,0.5)' }}>
            БАЛЛЫ СЕГОДНЯ
          </span>
        </h2>

        <p className="font-mono text-sm text-white/50 leading-relaxed mb-10 max-w-xl mx-auto">
          Зарегистрируйтесь и получите 100 приветственных баллов сразу. Начните экономить с первой же покупки.
        </p>

        {!registered ? (
          <div className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              type="tel"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              placeholder="+7 (___) ___-__-__"
              className="flex-1 px-5 py-4 rounded-full font-mono text-sm text-white bg-transparent outline-none"
              style={{ border: '1px solid rgba(240,255,0,0.3)', background: 'rgba(240,255,0,0.04)' }}
            />
            <button
              onClick={() => phone.length >= 10 && setRegistered(true)}
              className="whitespace-nowrap px-8 py-4 rounded-full font-orbitron font-bold text-sm cursor-pointer transition-all duration-300"
              style={{ background: '#f0ff00', color: '#050508', boxShadow: '0 0 30px rgba(240,255,0,0.4)' }}
            >
              ПОЛУЧИТЬ КАРТУ
            </button>
          </div>
        ) : (
          <div className="flex flex-col items-center gap-4">
            <div
              className="w-16 h-16 flex items-center justify-center rounded-full"
              style={{ background: 'rgba(57,255,20,0.15)', border: '2px solid #39ff14', boxShadow: '0 0 20px rgba(57,255,20,0.4)' }}
            >
              <i className="ri-check-line text-2xl" style={{ color: '#39ff14' }} />
            </div>
            <div>
              <div className="font-orbitron font-bold text-xl text-white mb-1">Заявка принята!</div>
              <p className="font-mono text-sm text-white/50">Мы отправим данные карты на номер <span style={{ color: '#39ff14' }}>{phone}</span></p>
            </div>
            <div className="flex items-center gap-2 px-4 py-2 rounded-full" style={{ background: 'rgba(240,255,0,0.08)', border: '1px solid rgba(240,255,0,0.2)' }}>
              <i className="ri-gift-2-line" style={{ color: '#f0ff00' }} />
              <span className="font-mono text-sm" style={{ color: '#f0ff00' }}>+100 приветственных баллов начислено!</span>
            </div>
          </div>
        )}

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
          {[
            { icon: 'ri-shield-check-line', text: 'Данные защищены', color: '#39ff14' },
            { icon: 'ri-lock-line', text: 'Без спама', color: '#00f5ff' },
            { icon: 'ri-time-line', text: 'Карта за 1 минуту', color: '#f0ff00' },
          ].map((b, i) => (
            <div key={i} className="flex items-center gap-2">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={b.icon} style={{ color: b.color, fontSize: '14px' }} />
              </div>
              <span className="font-mono text-xs text-white/40">{b.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LoyaltyCta;
